import { Component } from '@angular/core';

@Component({
  selector: 'dom436-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'treszerosetedom436-portal';
}
